import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const LinkinIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "LinkinIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
        fill="#0077B5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.8936 7.39853C8.8936 8.17595 8.33504 8.79802 7.4382 8.79802H7.42176C6.55825 8.79802 6 8.17595 6 7.39853C6 6.60466 6.57525 6 7.45515 6C8.33504 6 8.8769 6.60466 8.8936 7.39853ZM8.72415 9.90318V17.9998H6.15205V9.90318H8.72415ZM17.9999 17.9998L18 13.3574C18 10.8705 16.7311 9.71303 15.0385 9.71303C13.6729 9.71303 13.0615 10.4989 12.7201 11.0502V9.90337H10.1477C10.1816 10.6631 10.1477 18 10.1477 18H12.7201V13.4782C12.7201 13.2362 12.7368 12.9948 12.8048 12.8216C12.9907 12.3381 13.414 11.8376 14.1246 11.8376C15.0557 11.8376 15.4279 12.5801 15.4279 13.6681V17.9998H17.9999Z"
        fill="white"
      />
    </svg>
  );
};

export default LinkinIcon;
